import { NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { GalleryLayout9 } from '@components/gallery/components/gallery-layout-9/model';
import { ImageComponent } from '@shared/components/image';
import { QuoteComponent } from '@shared/components/quote';
import { VideoComponent } from '@shared/components/video';

@Component({
  selector: 'app-gallery-layout-9',
  imports: [NgTemplateOutlet, QuoteComponent, ImageComponent, VideoComponent],
  templateUrl: './gallery-layout-9.component.html',
  styleUrl: './gallery-layout-9.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GalleryLayout9Component {
  readonly data = input.required<GalleryLayout9>();
}
